import { useState } from 'react';


function Explore () {
  const [courses, setCourses] = useState([
    {
      id: 1,
      title: 'Tally Certification with Online Internship',
      image: 'https://tallyeducation.com/tepl/wp-content/uploads/2025/03/Online-Intership-100-1.png',
      tags: ['OFFLINE'],
      description:
        'Get hands-on Accounting experience with Tally’s NEP-aligned Online Internship',
      link: 'https://tallyeducation.com/tepl/online-internship/',
    },
    {
      id: 2,
      title: 'Tally Certification with GST Simulation',
      image: 'https://tallyeducation.com/tepl/wp-content/uploads/2025/02/GST-simulation-YT-Thumbnail_Without-logo.jpg',
      tags: ['OFFLINE'],
      description:
        'A Dynamic Platform for Practising GST Returns with Tally Certification to Level Up Your Career',
      link: 'https://tallyeducation.com/tepl/gst-simulation/',
    },
    // Add more courses here...
  ]);

  const [currentPage, setCurrentPage] = useState(1);
  const [coursesPerPage, setCoursesPerPage] = useState(2);

  const indexOfLastCourse = currentPage * coursesPerPage;
  const indexOfFirstCourse = indexOfLastCourse - coursesPerPage;
  const currentCourses = courses.slice(indexOfFirstCourse, indexOfLastCourse);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <main style={{ backgroundColor: '#FAFAFA' }}>
      {/* Banner */}
      <div className="container-fluid responsive-banner" style={{
        backgroundImage: 'url(https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/background-blue-pattern.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: 400,
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-7 offline-content-section-hero">
              <img src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/offline-courses-landing.png" style={{ width: 300 }} alt="Offline Courses" />
              <h1 className="mt-4" style={{ color: '#90b732' }}>
                Classroom-based
              </h1>
              <p className="text2 text-grey mt-3 mb-md-0">
                Master Computerised Accounting with Tally’s Expert-led Offline Courses
              </p>
              <ul className="list-unstyled mt-3 mx-md-2 mx-lg-2 text-start text-md-none p-2 p-md-0">
                <li style={{ marginBottom: 2 }}>
                  <i className="bi bi-caret-right-fill" style={{ color: '#90b732', fontSize: 15 }}></i>
                  <p className="d-inline text2 text-grey ms-2">
                    Industry-relevant curriculum tailored to boost your accounting and finance expertise
                  </p>
                </li>
                <li style={{ marginBottom: 2 }}>
                  <i className="bi bi-caret-right-fill" style={{ color: '#90b732', fontSize: 15 }}></i>
                  <p className="d-inline text2 text-grey ms-2">
                    Learn from Tally certified professionals with real-world experience
                  </p>
                </li>
              </ul>
            </div>
            <div className="col-md-5 position-relative">
              <img src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/courses-offline-banner-new.jpg" className="w-100 rounded-3 position-absolute offline-all-page-hero-img" alt="Offline Courses" />
            </div>
          </div>
        </div>
      </div>

      {/* Course Overview Section */}
      <section className="course-categories-section">
        <div className="container p-xl-0">
          <div className="row">
            {/* Course Categories */}
            <div className="col-md-4 marginTop d-md-flex">
              <div className="course-categories-container">
                <p className="cta1 m-0">Course Categories</p>
                <div id="offline-category">
                  {[
                    { id: 1, name: 'All Courses' },
                    { id: 2, name: 'Popular Courses' },
                    { id: 3, name: 'International Courses' },
                    { id: 4, name: 'Specialisation Courses' },
                  ].map((category) => (
                    <button
                      key={category.id}
                      className="label-semibold course-category"
                      onClick={() => console.log(category.name)}
                    >
                      {category.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Course List */}
            <div className="col-md-8 allCourses mt-5 mt-md-0">
              <h4 className="mb-4 heading4 category-section" id="allCourses">
                All Courses
              </h4>
              <div className="container mt-3 pe-0 ps-0">
                <ul className="courses-card mb-5 flex-wrap courses-card-style">
                  {currentCourses.map((course) => (
                    <li
                      key={course.id}
                      className="mb-5 position-relative li card-item shadow"
                    >
                      <img
                        src={course.image}
                        alt=""
                        className="img-fluid mb-3 w-100"
                        style={{
                          borderRadius: 8,
                          cursor: 'pointer',
                        }}
                        onClick={() => window.open(course.link, '_blank')}
                      />
                      <div className="cta2 card-tag">{course.tags[0]}</div>
                      <div>
                        <div style={{ minHeight: 122 }} className="px-2">
                          <div className="card-heading-div">
                            <p className="text1-bold">{course.title}</p>
                          </div>
                          <div style={{ height: 50 }}>
                            <p className="label-med w-100">{course.description}</p>
                          </div>
                        </div>
                        <div className="p-2 text-center">
                          <button
                            className="course-view-details-button w-50"
                            onClick={() => window.open(course.link, '_blank')}
                          >
                            View Details
                          </button>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
                <ul className="pagination mt-4">
                  <li className="page-item disabled" id="prev-page">
                    <button className="page-link rounded-5" disabled>
                      <i className="fas fa-arrow-left" style={{ color: '#90b732' }}></i>
                    </button>
                  </li>
                  {[1, 2].map((pageNumber) => (
                    <li
                      key={pageNumber}
                      className={`page-item ${pageNumber === currentPage ? 'active' : ''}`}
                      data-page={pageNumber}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(pageNumber)}
                      >
                        {pageNumber}
                      </button>
                    </li>
                  ))}
                  <li className="page-item" id="next-page">
                    <button className="page-link rounded-5" onClick={() => handlePageChange(currentPage + 1)}>
                      <i className="fas fa-arrow-right" style={{ color: '#90b732' }}></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <hr className="mb-5" />
          </div>
        </div>
      </section>

      {/* Why Choose Tally’s Offline Courses */}

      <div className="mt-5">
        <div className="container">
          <div className="why-tally-certification text-center">
            <h2 className="heading2 mb-5">Why Choose Tally’s Offline Courses?</h2>
          </div>

          <div className="d-flex justify-content-between flex-wrap flex-xl-nowrap mb-md-5">
            <div className="benefit-name-container">
              <div className="row mb-md-4 benefit-name-cards justify-content-around">
                <div className="col-md-4 mb-4 text-center text-md-start">
                  <img
                    src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/Expert Training.png"
                    alt="icon"
                    className="mb-3 mx-auto"
                  />
                  <h4 className="label-bold mb-2">Expert Training</h4>
                  <p className="text2 text-grey">
                    Tally certified faculty guide your learning journey with hands-on experience and
                    proven teaching methodologies.
                  </p>
                </div>
                <div className="col-md-4 mb-4 text-center text-md-start">
                  <img
                    src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/Practical Experience.png"
                    alt="icon"
                    className="mb-3 mx-auto"
                  />
                  <h4 className="label-bold mb-2">Practical Experience</h4>
                  <p className="text2 text-grey">
                    Real-world scenarios and extensive lab practice ensure you are job-ready from day
                    one.
                  </p>
                </div>
              </div>

              <div className="row mb-md-4 benefit-name-cards justify-content-around">
                <div className="col-md-4 mb-4 text-center text-md-start">
                  <img
                    src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/Career Support.png"
                    alt="icon"
                    className="mb-3 mx-auto"
                  />
                  <h4 className="label-bold mb-2">Career Support</h4>
                  <p className="text2 text-grey">
                    Lifetime access to Tally Job Portal and dedicated placement assistance to kickstart
                    your career.
                  </p>
                </div>
                <div className="col-md-4 mb-4 text-center text-md-start">
                  <img
                    src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/Industry Recognition.png"
                    alt="icon"
                    className="mb-3 mx-auto"
                  />
                  <h4 className="label-bold mb-2">Industry Recognition</h4>
                  <p className="text2 text-grey">
                    Globally acknowledged certification that validates your expertise in computerized
                    accounting
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQs */}
      <div className="faq-section">
        <ul className="faq-list">
          <div className="container my-5">
            <div className="row">
              <div className="col-md-8 col-sm-8">
                <div id="faq" className="tab-content">
                  <h4 className="heading4" id="faqs">
                    Frequently Asked Questions (FAQs)
                  </h4>
                  <p className="text2 text-grey mb-5"></p>
                  <div className="accordion accordion-faq mb-4 text-start" id="accordion-faq">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="heading-1">
                        <button
                          className="accordion-button collapsed text2"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse-1"
                          aria-expanded="false"
                          aria-controls="collapse-1"
                        >
                          1. Who can enroll in these offline courses?
                        </button>
                      </h2>
                      <div id="collapse-1" className="accordion-collapse collapse" aria-labelledby="heading-1" data-bs-parent="#accordion-faq">
                        <div className="accordion-body text3 text-grey">
                          <div>
                            <p>
                              These courses are highly recommended for learners who aspire to build
                              successful career in Accounts, Finance, Taxation, Administration and Banking
                              sectors, or as an entrepreneur.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="heading-2">
                        <button
                          className="accordion-button collapsed text2"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse-2"
                          aria-expanded="false"
                          aria-controls="collapse-2"
                        >
                          2. How can I enroll in the offline course?
                        </button>
                      </h2>
                      <div id="collapse-2" className="accordion-collapse collapse" aria-labelledby="heading-2" data-bs-parent="#accordion-faq">
                        <div className="accordion-body text3 text-grey">
                          <p>
                            You can enroll for the course through our partner network spread across the
                            country and globally.{' '}
                            <a href="https://tallyeducation.com/tepl/learning" target="_blank" rel="noopener">
                              Locate A Centre
                            </a>
                            {' '}
                            nearby and enroll today for the course.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="heading-3">
                        <button
                          className="accordion-button collapsed text2"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse-3"
                          aria-expanded="false"
                          aria-controls="collapse-3"
                        >
                          3. How will these offline courses help me in my career?
                        </button>
                      </h2>
                      <div id="collapse-3" className="accordion-collapse collapse" aria-labelledby="heading-3" data-bs-parent="#accordion-faq">
                        <div className="accordion-body text3 text-grey">
                          <p>
                            Upon successfully completing the course, you will have a comprehensive
                            understanding of finance and accounting and the ability to apply that
                            understanding to a variety of real-world scenarios, whether you’re using this
                            knowledge in the field of business decision-making or as a student of
                            finance/accounting for higher studies.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="heading-4">
                        <button
                          className="accordion-button collapsed text2"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse-4"
                          aria-expanded="false"
                          aria-controls="collapse-4"
                        >
                          4. Is there an assessment or certification?
                        </button>
                      </h2>
                      <div id="collapse-4" className="accordion-collapse collapse" aria-labelledby="heading-4" data-bs-parent="#accordion-faq">
                        <div className="accordion-body text3 text-grey">
                          <p>
                            Yes, our offline courses include a final assessment. Successful completion
                            awards an industry-recognised, verifiable certificate to boost your
                            employment prospects.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="heading-5">
                        <button
                          className="accordion-button collapsed text2"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse-5"
                          aria-expanded="false"
                          aria-controls="collapse-5"
                        >
                          5. What placement assistance does Tally provide?
                        </button>
                      </h2>
                      <div id="collapse-5" className="accordion-collapse collapse" aria-labelledby="heading-5" data-bs-parent="#accordion-faq">
                        <div className="accordion-body text3 text-grey">
                          <p>
                            We offer comprehensive placement support through internships, campus drives/job
                            fairs, industry connects, and placement events to help you secure the right
                            job opportunity.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </main>
  );
}

export default Explore ;

